import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs';

import { LocalizedLinkPipe } from '../../../pipes/localized-link.pipe';
import { AnalyticsService } from '../../../services/analytics.service';
import { UserSessionService } from '../../../services/user-session.service';
import { Dropdown } from '../dropdown/dropdown';
import { Icon } from '../icon/icon';

@Component({
  imports: [RouterLink, TranslatePipe, Dropdown, Icon, LocalizedLinkPipe],
  selector: 'app-profile-menu',
  standalone: true,
  styleUrl: './profile-menu.scss',
  templateUrl: './profile-menu.html',
})
export class ProfileMenu {
  protected readonly avatarFailed = signal(false);

  protected readonly menuDropdown = viewChild<Dropdown>('menuDropdown');
  private readonly userSessionService = inject(UserSessionService);
  protected readonly session = this.userSessionService.session;

  private readonly analytics = inject(AnalyticsService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly router = inject(Router);

  constructor() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.userSessionService.load().subscribe();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.menuDropdown()?.close());
  }

  protected logout(): void {
    this.analytics.trackEvent('logout', { method: 'discord' });
    this.menuDropdown()?.close();
    this.userSessionService.logout().subscribe();
  }

  protected onAvatarError(): void {
    this.avatarFailed.set(true);
  }

  protected trackLogin(): void {
    this.analytics.trackEvent('login', { method: 'discord' });
  }
}
